import { installReportCard } from './card/install'
import { inistallReportEcharts } from './echarts'
export function createReportFormComponents() {
  try {
    return [
      ...installReportCard(),
      ...inistallReportEcharts()
    ]
  } catch (e) {
    return []
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/install.js